import createIcon from '../../createIcon';

/**
 * @component @name CloseFullscreen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMy40MUwxNi43MSA4LjdMMjAgMTJIMTJWNEwxNS4yOSA3LjI5TDIwLjU5IDJMMjIgMy40MVpNMy40MSAyMkw4LjcgMTYuNzFMMTIgMjBWMTJINEw3LjI5IDE1LjI5TDIgMjAuNTlMMy40MSAyMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CloseFullscreen = createIcon('CloseFullscreen', [
  [
    'path',
    {
      d: 'M22 3.41L16.71 8.7L20 12H12V4L15.29 7.29L20.59 2L22 3.41ZM3.41 22L8.7 16.71L12 20V12H4L7.29 15.29L2 20.59L3.41 22Z',
      key: 'hpyt5w',
    },
  ],
]);

export default CloseFullscreen;
